export default __webpack_public_path__ + "bfx/static/media/icon-TEAM.b6ce6b60.svg";